/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AmoxcalliInstitutionGradeDtoApiResponse } from '../../models/amoxcalli-institution-grade-dto-api-response';
import { AmoxcalliUpdateInstitutionGradeDto } from '../../models/amoxcalli-update-institution-grade-dto';

export interface ApiInstitutionGradesIdPut$Json$Params {
  id: string;
      body?: AmoxcalliUpdateInstitutionGradeDto
}

export function apiInstitutionGradesIdPut$Json(http: HttpClient, rootUrl: string, params: ApiInstitutionGradesIdPut$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<AmoxcalliInstitutionGradeDtoApiResponse>> {
  const rb = new RequestBuilder(rootUrl, apiInstitutionGradesIdPut$Json.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AmoxcalliInstitutionGradeDtoApiResponse>;
    })
  );
}

apiInstitutionGradesIdPut$Json.PATH = '/api/institution-grades/{id}';
